import { render, staticRenderFns } from "./search-feedback.vue?vue&type=template&id=77f5dfa0"
import script from "./search-feedback.vue?vue&type=script&lang=js"
export * from "./search-feedback.vue?vue&type=script&lang=js"
import style0 from "./search-feedback.vue?vue&type=style&index=0&id=77f5dfa0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports